import moment from "moment-timezone";

// Get timezone options for select
export const getTimezoneOptions = () => {
  return moment.tz.names().map((tz) => ({
    value: tz,
    label: `${tz} (${moment.tz(tz).format("Z")})`,
  }));
};
